<template>
	<b-modal v-model="show" :header="false" :footer="false" class="fade backdrop" @hide="close">
		<div slot="default">
			<div class="iadsa-modal-header">
				<b-btn class="close btn btn-head-modal" @click="show=false">
					<i class="material-icons">close</i>
				</b-btn>
			</div>
			<div class="iadsa-modal-body">
				<h2>Edit {{ details.type }}</h2>
				<p>
					Enter a new name for:
					<br>
					<span class="medium blue">{{ details.name }}</span>
				</p>
				<label
					v-if="$v.newValue.$error && !$v.newValue.required"
					class="label error pull-right"
				>Required</label>
				<input
					v-model="newValue"
					type="text"
					:class="{ 'error': $v.newValue.$error }"
					class="form-control"
					style="height:40.25px;"
					placeholder="New name"
					@keyup.enter="editItem(details.id)"
				/>
				<div style="margin-top:30px">
					<b-btn class="btn btn-info" @click="editItem(details.id)">
						<strong>Save</strong>
					</b-btn>
					<b-btn class="btn btn-default" @click="show=false">
						Cancel
					</b-btn>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<style lang="less" scoped>
	.btn {
		margin-right: 5px;
	}
	.error {
		border-color: red;
		color: red;
	}
</style>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
	props: {
		showModal: {
			type: Boolean,
			required: true
		},
		details: {
			type: Object,
			default: null
		}
	},
	validations: {
		newValue: { required, minLength: minLength(1) }
	},
	data() {
		return {
			show: false,
			newValue: null
		};
	},
	watch: {
		showModal() {
			this.show = this.showModal;
		}
	},
	methods: {
		close() {
			this.$emit('closeEditModal');
		},
		editItem(id) {
			if (this.$v.newValue.$invalid) {
				this.$v.newValue.$touch();
			} else {
				this.$emit('edit', id, { value: this.newValue });
				this.newValue = null;
			}
		}
	}
};
</script>
